import { useOidc } from '@axa-fr/react-oidc';
import { useEffect } from 'react';
import { useAuthToken } from '../../hooks/useAuthToken';
import {
  configureAxiosAuthErrorHandler,
  configureAxiosWithToken,
  resetAxiosConfig,
} from '../axiosConfig';

const AxiosProvider = ({ children }) => {
  const { accessToken, isAuthenticated } = useAuthToken();
  const { login } = useOidc();

  useEffect(() => {
    if (isAuthenticated && accessToken) {
      // Configurer axios avec le token d'authentification
      configureAxiosWithToken(() => accessToken);
    } else {
      // Réinitialiser la configuration si l'utilisateur n'est pas authentifié
      resetAxiosConfig();
    }
  }, [accessToken, isAuthenticated]);

  useEffect(() => {
    // Sur un 401 de l'API (token absent/expiré), relancer l'authentification
    // au lieu de laisser des erreurs muettes.
    configureAxiosAuthErrorHandler(() => {
      const current = window.location.pathname + window.location.search;
      if (!current.startsWith('/auth/')) {
        sessionStorage.setItem('redirectPath', current);
      }
      login(current);
    });
  }, [login]);

  return children;
};

export default AxiosProvider;
